<template>
  <div class="penthouse" id="penthouse">
    <info :backImage="imagePath" class="scrollFade"></info>
    <template v-for="(content, index) in descriptionContent">
      <description
        :key="index"
        :description-title="content.title"
        :description-body="content.text"
        :image="content.image"
        :class="'penthouse-description-' + index">
      </description>
    </template>
    <footer-part></footer-part>
  </div>
</template>

<script>
  import Description from "../components/Description";
  import Info from "../components/Info";
  import Footer from "../layout/Footer";

  export default {
    name: "Penthouse",
    data: () => ({
      descriptionContent: [],
      imagePath: '',
      showPenthouse: false
    }),
    components: {
      Description,
      Info,
      'footer-part': Footer
    },
    created() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        fetch('/pages/penthouse')
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                this.imagePath = data[0].image;
                this.descriptionContent = data.slice(1, data.length)
                this.showPenthouse = true
            });
      },
      handleScroll () {

            // Scroll fade
            let slides = document.getElementsByClassName("scrollFade");
            let slidesTitle = document.getElementsByClassName("scrollFadeText");
            let slidesBody = document.getElementsByClassName("scrollFadeBody");


            for (let i = 0; i < slidesTitle.length; i++) {
                let elPos = slidesTitle[i].getBoundingClientRect().top
                if(elPos < 60) {
                    slidesTitle[i].style.opacity = (elPos / 60)
                } else {
                    slidesTitle[i].style.opacity = 1
                }
            }

            for (let i = 0; i < slidesBody.length; i++) {
                let elPos = slidesBody[i].getBoundingClientRect().top
                if(elPos < 60) {
                    slidesBody[i].style.opacity = (elPos / 60)
                } else {
                    slidesBody[i].style.opacity = 1
                }
            }

          for (let i = 0; i < slides.length; i++) {
              let elPos = slides[i].getBoundingClientRect().top
              const elHeight = slides[i].offsetHeight
              const elPositionBottom = slides[i].getBoundingClientRect().bottom
              if(elPos < 0) {
                  slides[i].style.opacity = ( elPositionBottom / elHeight)
              } else {
                  slides[i].style.opacity = 1
              }
          }
        }
    },
    mounted () {
      document.getElementById('penthouse').addEventListener('scroll', this.handleScroll);
    },
  }
</script>

<style scoped>

</style>
